module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form form-inline">\n    <button class="btn btn-primary btn-sm" id="expand-all">Expand All</button>\n    <button class="btn btn-primary btn-sm" id="collapse-all">Collapse All</button>\n    <button class="btn btn-primary btn-sm" id="expand-required">Expand Required</button>\n    <button class="btn btn-primary btn-sm" id="expand-filled">Expand Filled</button>\n</div>\n\n<div id="document-meta-content" class="panel-group top-margined">\n    ';
 _.each(meta, function(item, index){ 
__p+='\n    <div class="panel panel-info">\n        <div class="panel-heading">\n            <h4 class="panel-title">\n                <a data-toggle="collapse" data-parent="#document-meta-content" href="#'+
((__t=( item.field + index ))==null?'':__t)+
'">\n                    '+
((__t=( getFieldTitle(item.field) ))==null?'':__t)+
' '+
((__t=( requiredDocumentMetaFields(item.field) ))==null?'':__t)+
'\n                </a>\n            </h4>\n        </div>\n        <div id="'+
((__t=( item.field + index ))==null?'':__t)+
'" class="panel-collapse collapse">\n            <div class="panel-body">\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Related '+
((__t=( requiredDocumentMetaFieldsValues(item.field, "related") ))==null?'':__t)+
'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
((__t=( 'related' + ' ' + index ))==null?'':__t)+
'" value="'+
((__t=( item.related ))==null?'':_.escape(__t))+
'">\n                    </div>\n                </div>\n\n                ';
 if (item.field == 'classCode' || item.field == 'confidentialityCode' || item.field == 'formatCode' || item.field == 'healthcareFacilityTypeCode'
                || item.field == 'practiceSettingCode' || item.field == 'typeCode') { 
__p+='\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Node representation '+
((__t=( requiredDocumentMetaFieldsValues(item.field, "nodeRepresentation") ))==null?'':__t)+
'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <select id="'+
((__t=( 'nodeRepresentation' + ' ' + index ))==null?'':__t)+
'" class="meta-val meta-values">\n                            ';
 _.each(getPredefinedMetaCodesOrCodeNames(item.field, item.nodeRepresentation, 1), function(code){ 
__p+='\n                            <option value="'+
((__t=( code ))==null?'':__t)+
'" ';
if (code == item.nodeRepresentation) {
__p+=' selected ';
 } 
__p+=' >'+
((__t=( code ))==null?'':__t)+
'</option>\n                            ';
 }) 
__p+='\n                        </select>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Name (localized string) '+
((__t=( requiredDocumentMetaFieldsValues(item.field, "nameLocalizedString") ))==null?'':__t)+
'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <select id="'+
((__t=( 'nameLocalizedString' + ' ' + index ))==null?'':__t)+
'" class="meta-val meta-values">\n                            ';
 _.each(getPredefinedMetaCodesOrCodeNames(item.field, item.nameLocalizedString, 0), function(code){ 
__p+='\n                            <option value="'+
((__t=( code ))==null?'':__t)+
'" ';
if (code == item.nameLocalizedString) {
__p+=' selected ';
 } 
__p+=' >'+
((__t=( code ))==null?'':__t)+
'</option>\n                            ';
 }) 
__p+='\n                        </select>\n                    </div>\n                </div>\n                ';
 } else { 
__p+='\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Node representation '+
((__t=( requiredDocumentMetaFieldsValues(item.field, "nodeRepresentation") ))==null?'':__t)+
'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
((__t=( 'nodeRepresentation' + ' ' + index ))==null?'':__t)+
'" value="'+
((__t=( item.nodeRepresentation ))==null?'':_.escape(__t))+
'">\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Name (localized string) '+
((__t=( requiredDocumentMetaFieldsValues(item.field, "nameLocalizedString") ))==null?'':__t)+
'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
((__t=( 'nameLocalizedString' + ' ' + index ))==null?'':__t)+
'" value="'+
((__t=( item.nameLocalizedString ))==null?'':_.escape(__t))+
'">\n                    </div>\n                </div>\n                ';
 } 
__p+='\n\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Slot name '+
((__t=( requiredDocumentMetaFieldsValues(item.field, "slotName") ))==null?'':__t)+
'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
((__t=( 'slotName' + ' ' + index ))==null?'':__t)+
'" value="'+
((__t=( item.slotName ))==null?'':_.escape(__t))+
'">\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Coding scheme '+
((__t=( requiredDocumentMetaFieldsValues(item.field, "codingScheme") ))==null?'':__t)+
'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
((__t=( 'codingScheme' + ' ' + index ))==null?'':__t)+
'" value="'+
((__t=( item.codingScheme ))==null?'':_.escape(__t))+
'">\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Description '+
((__t=( requiredDocumentMetaFieldsValues(item.field, "description") ))==null?'':__t)+
'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
((__t=( 'description' + ' ' + index ))==null?'':__t)+
'" value="'+
((__t=( item.description ))==null?'':_.escape(__t))+
'">\n                    </div>\n                </div>\n\n                ';
 _.each(item.value, function(v, valueIndex){ 
__p+='\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Value '+
((__t=( requiredDocumentMetaFieldsValues(item.field, "value") ))==null?'':__t)+
'</label>\n                    <div class="col-xs-8 col-md-8">\n                        ';
 if (item.field == 'mimeType') { 
__p+='\n                        <select id="'+
((__t=( 'value' + ' ' + index + ' ' + valueIndex ))==null?'':__t)+
'" class="meta-val meta-values">\n                            ';
 _.each(getMimeTypes(item.value[valueIndex]), function(mimeType){ 
__p+='\n                            <option value="'+
((__t=( mimeType ))==null?'':__t)+
'" ';
if (mimeType == item.value[valueIndex]) {
__p+=' selected ';
 } 
__p+=' >'+
((__t=( mimeType ))==null?'':__t)+
'</option>\n                            ';
 }) 
__p+='\n                        </select>\n                        ';
 } else if (item.field == 'creationTime' || item.field == 'serviceStartTime' || item.field == 'serviceStopTime') { 
__p+='\n                        <input class="form-control meta-val date-value" type="text" id="'+
((__t=( 'value' + ' ' + index + ' ' + valueIndex ))==null?'':__t)+
'" value="'+
((__t=( item.value[valueIndex] ))==null?'':_.escape(__t))+
'">\n                        ';
 } else {
__p+='\n                        <input class="form-control meta-val" type="text" id="'+
((__t=( 'value' + ' ' + index + ' ' + valueIndex ))==null?'':__t)+
'" value="'+
((__t=( item.value[valueIndex] ))==null?'':_.escape(__t))+
'">\n                        ';
 } 
__p+='\n                    </div>\n\n                    ';
 if (isMultipleValueAllowed(item.field)) { 
__p+='\n                        ';
 if (valueIndex === item.value.length - 1) { 
__p+='\n                        <div class="col-xs-1 col-md-1">\n                                                <span class="glyphicon glyphicon-plus-sign clickable control-label add-value"\n                                                      id="'+
((__t=( 'add_value' + ' ' + index ))==null?'':__t)+
'" title="'+
((__t=( addMoreValuesText ))==null?'':__t)+
'"/>\n                        </div>\n                        ';
 } else { 
__p+='\n                        <div class="col-xs-1 col-md-1">\n                                                    <span class="glyphicon glyphicon-minus-sign clickable control-label remove-value"\n                                                          id="'+
((__t=( 'remove_value' + ' ' + index + ' ' + valueIndex ))==null?'':__t)+
'"/>\n                        </div>\n                        ';
 } 
__p+='\n                    ';
 } 
__p+='\n\n                </div>\n\n                ';
 }) 
__p+='\n\n            </div>\n        </div>\n    </div>\n    ';
 }) 
__p+='\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/document-meta-form.html
// module id = 396
// module chunks = 0